import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

type InfoBlockContentProps = {};

const InfoBlockContent = ({
    children
}: RequireChildrenFor<InfoBlockContentProps>) => {
    return (
        <section
            className={cn(
                "tw:max-lg:overflow-hidden tw:max-lg:max-h-0",
                "tw:group-[.info-block--active]/info-block:block tw:group-[.info-block--active]/info-block:max-h-[10000px]",
                "tw:group-[.info-block--active]/info-block:transition-[max-height] tw:group-[.info-block--active]/info-block:duration-700 tw:group-[.info-block--active]/info-block:ease-in-out"
            )}
        >
            {children}
        </section>
    );
};

export { InfoBlockContent };
